import { useState, useEffect, useContext } from 'react';

import _ from 'lodash';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';

export function usePageConfigsState({ initialData }) {
  const { setSuccessMessage } = useContext(GeneralContext);

  const [configs, setConfigs] = useState({
    backgroundColor: '',
    headerFooterColor: '',
    primaryColor: '',
    secondaryColor: '',
    fontColor: '',
    fontColorSecondary: '',
    footerIconsColor: '',
    fontFamily: '',
    logoUrl: '',
    faviconUrl: '',
    mainImageUrl: '',
    mainImageMobileUrl: '',
    instagramAccount: '',
    facebookAccount: '',
    linkedinAccount: '',
    tiktokAccount: '',
    contactEmail: '',
    link1Title: '',
    link1Url: '',
    link2Title: '',
    link2Url: '',
    mainImageSizingMode: '',
    mainImageMobileSizingMode: '',
    publicPageEndpoint: '',
  });
  const [logoFile, setLogoFile] = useState(null);
  const [faviconFile, setFaviconFile] = useState(null);
  const [mainImageFile, setMainImageFile] = useState(null);
  const [mainImageMobileFile, setMainImageMobileFile] = useState(null);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (initialData) {
      setConfigs(initialData);
    }
  }, [initialData]);

  useEffect(() => {
    if (
      !_.isEqual(initialData, configs) ||
      logoFile ||
      faviconFile ||
      mainImageFile
    ) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  }, [configs, logoFile, faviconFile, mainImageFile]);

  function discartChanges() {
    setConfigs(initialData);
    setLogoFile(null);
    setFaviconFile(null);
    setMainImageFile(null);
    setMainImageMobileFile(null);
    setSuccessMessage('Alterações descartadas com sucesso!');
  }

  return {
    configs,
    setConfigs,
    logoFile,
    setLogoFile,
    faviconFile,
    setFaviconFile,
    mainImageFile,
    setMainImageFile,
    mainImageMobileFile,
    setMainImageMobileFile,
    discartChanges,
    isChanged,
  };
}
